var _path, _mask, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBgPatternHeader(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 768,
    viewBox: "0 0 768 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M768 0H0V60C0 115.228 44.7715 160 100 160H768V0Z",
    fill: "#5964E0"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 768
  }, /*#__PURE__*/React.createElement("path", {
    d: "M768 0H0V60C0 115.228 44.7715 160 100 160H768V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.0813802,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M254.539 -323.259C251.422 -355.051 284.25 -378.038 313.059 -364.235L657.22 -199.337C685.511 -185.781 688.718 -146.77 663.02 -128.776L356.104 86.1286C330.406 104.122 294.845 87.766 291.783 56.5447L254.539 -323.259Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.0813802,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-71.4608 71.7412C-74.5785 39.9487 -41.7496 16.9617 -12.9407 30.765L331.22 195.663C359.511 209.219 362.718 248.23 337.02 266.224L30.1041 481.129C4.40643 499.122 -31.1552 482.766 -34.2168 451.545L-71.4608 71.7412Z",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgPatternHeader);
export default __webpack_public_path__ + "static/media/bg-pattern-header.45e3da63f68f84b3827eca4eda2a39a8.svg";
export { ForwardRef as ReactComponent };